import createIcon from '../../createIcon';

/**
 * @component @name CompareArrows
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS4wMSAxNEgyVjE2SDkuMDFWMTlMMTMgMTVMOS4wMSAxMVYxNFpNMTQuOTkgMTNWMTBIMjJWOEgxNC45OVY1TDExIDlMMTQuOTkgMTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CompareArrows = createIcon('CompareArrows', [
  [
    'path',
    {
      d: 'M9.01 14H2V16H9.01V19L13 15L9.01 11V14ZM14.99 13V10H22V8H14.99V5L11 9L14.99 13Z',
      key: 'r1nd6f',
    },
  ],
]);

export default CompareArrows;
